var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-list-item",
    { staticClass: "lesson-detail-purchase-option gap-4" },
    [
      _c("v-list-item-avatar", [_c("v-icon", [_vm._v("local_mall")])], 1),
      _vm._v(" "),
      _c(
        "v-list-item-content",
        { staticClass: "soli-grey" },
        [
          _c("v-list-item-subtitle", [_vm._v("Purchase Option")]),
          _vm._v(" "),
          _c("v-list-item-title", { staticClass: "mb-1" }, [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm.purchaseOption
                    ? `${_vm.purchaseOption.name}`
                    : `${_vm.event.type}`
                ) +
                "\n        "
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex gap-1 align-center flex-wrap mb-05" },
            _vm._l(_setup.getTags, function (tag) {
              return _c(
                "v-chip",
                {
                  key: tag.id,
                  staticClass: "white--text font-weight-bold text-capitalize",
                  attrs: { "x-small": "", color: tag.color },
                },
                [_vm._v(_vm._s(tag.name))]
              )
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }